import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.125"
    }, [
      _createElementVNode("path", { d: "M8.338 1.5h-1.5c-3.75 0-5.25 1.5-5.25 5.25v4.5c0 3.75 1.5 5.25 5.25 5.25h4.5c3.75 0 5.25-1.5 5.25-5.25v-1.5" }),
      _createElementVNode("path", {
        "stroke-miterlimit": "10",
        d: "m12.118 2.265-5.91 5.91c-.225.225-.45.667-.495.99l-.323 2.257c-.12.818.458 1.388 1.275 1.275l2.258-.322c.315-.045.757-.27.99-.495l5.91-5.91c1.02-1.02 1.5-2.205 0-3.705s-2.685-1.02-3.705 0"
      }),
      _createElementVNode("path", {
        "stroke-miterlimit": "10",
        d: "M11.27 3.113a5.36 5.36 0 0 0 3.705 3.705"
      })
    ], -1)
  ]))]))
}
export default { render: render }